import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ErrorHandling } from "../../utility/ErrorHandling";
import { useNavigate } from "react-router-dom";

export function QueryClientProviderConfig({ children }) {
  const navigate = useNavigate();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
        retry: (failureCount, error: any) => {
          if (error?.response?.status == 401) {
            return false;
          }

          if (failureCount <= 6) {
            return true;
          }
          return false;
        },
        onError: (error: any) => {
          ErrorHandling(error, navigate);
        },
        // useErrorBoundary(error: any, query) {
        //   if (error?.response?.status != 422) {
        //     return true;
        //   }
        //   return false;
        // },
      },
      mutations: {
        retry: (failureCount, error: any) => {
          if (error?.response?.status == 401) {
            return false;
          }
          if (error?.response?.status == 422) {
            return false;
          }

          if (failureCount <= 6) {
            return true;
          }
          return false;
        },
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
}
